(function(){
  'use strict';
  if(window.__orangeSkuFitInitialized)return;
  window.__orangeSkuFitInitialized=true;
  var cardSelector='.dc-lp-bundle-option, .orange-pack';
  var observer=typeof ResizeObserver==='function'?new ResizeObserver(schedule):null;
  var scheduled=false,fitting=false;
  function lines(element){
    var range=document.createRange();
    range.selectNodeContents(element);
    var tops=[];
    Array.prototype.slice.call(range.getClientRects()).forEach(function(rect){
      if(rect.width<0.1||rect.height<0.1)return;
      if(!tops.some(function(top){return Math.abs(top-rect.top)<2;}))tops.push(rect.top);
    });
    return tops.length;
  }
  function fit(element,maxLines,minimum){
    if(!element||!element.getClientRects().length)return;
    element.style.removeProperty('font-size');
    element.style.removeProperty('transform');
    var initial=parseFloat(window.getComputedStyle(element).fontSize);
    if(!initial||element.clientWidth<5)return;
    var size=initial;
    for(var i=0;i<50;i++){
      if(element.scrollWidth<=element.clientWidth+1&&(!maxLines||lines(element)<=maxLines))break;
      if(size<=minimum)break;
      size=Math.max(minimum,size-0.5);
      element.style.setProperty('font-size',size+'px','important');
    }
    if(!maxLines&&element.scrollWidth>element.clientWidth+1){
      var ratio=(element.clientWidth-1)/Math.max(1,element.scrollWidth);
      element.style.setProperty('transform-origin','right center');
      element.style.setProperty('transform','scaleX('+Math.max(0.55,ratio)+')');
    }
  }

  // One responsive source for the collapsed SKU copy on product and landing pages.
  // Enlarge only its layout width before scaling the copy; the frame and BUY NOW stay fixed.
  function fitStickyCopy(product){
    var bar=product.closest('.orange-sticky-cart');
    if(!bar||bar.hidden||bar.classList.contains('is-open')||!product.getClientRects().length)return;
    var copy=product.querySelector('.orange-sticky-cart__copy');
    if(!copy)return;

    copy.style.removeProperty('width');
    copy.style.removeProperty('transform');
    copy.style.removeProperty('transform-origin');

    var prices=copy.querySelector('.orange-sticky-cart__prices');
    if(prices){
      prices.style.setProperty('flex-wrap','nowrap');
      prices.style.setProperty('white-space','nowrap');
    }
    var available=product.clientWidth;
    if(available<5)return;

    var title=copy.querySelector('[data-orange-sticky-title]');
    var detail=copy.querySelector('[data-orange-sticky-variant]');
    var needed=0;
    if(title&&title.getClientRects().length)needed=Math.max(needed,title.scrollWidth);
    if(detail&&detail.getClientRects().length)needed=Math.max(needed,detail.scrollWidth);

    if(prices&&prices.getClientRects().length){
      var priceNodes=[].slice.call(prices.querySelectorAll('b,s')).filter(function(node){
        return !node.hidden&&node.getClientRects().length;
      });
      var gap=parseFloat(window.getComputedStyle(prices).columnGap)||0;
      var priceNeeded=priceNodes.reduce(function(total,node){
        return total+Math.max(node.scrollWidth,node.getBoundingClientRect().width);
      },0)+gap*Math.max(0,priceNodes.length-1);
      needed=Math.max(needed,priceNeeded,prices.scrollWidth);
    }

    if(needed<=available-1)return;
    var scale=Math.max(.05,Math.min(1,(available-2)/needed));
    copy.style.setProperty('width',(100/scale).toFixed(4)+'%');
    copy.style.setProperty('transform-origin','left center');
    copy.style.setProperty('transform','scale('+scale.toFixed(5)+')');
  }
  function refresh(){
    fitting=true;
    document.querySelectorAll(cardSelector).forEach(function(card){
      // Landing page cards already use their own adaptive master; fit only the collapsed Sticky there.
      if(card.closest('.dc-lp-first-screen, [data-orange-landing-sticky]'))return;
      if(!card.getClientRects().length)return;
      fit(card.querySelector('.dc-lp-bundle-option__title'),2,10);
      fit(card.querySelector('.dc-lp-bundle-option__price strong, .orange-pack__price strong'),0,10);
      fit(card.querySelector('.dc-lp-bundle-option__was s, .orange-pack__price s'),0,9);
      fit(card.querySelector('.dc-lp-bundle-option__save-pill, .orange-pack__deal'),0,8.5);
      if(observer&&!card.dataset.orangeSkuObserved){
        observer.observe(card);
        card.dataset.orangeSkuObserved='true';
      }
    });
    document.querySelectorAll('.orange-sticky-cart__product').forEach(function(product){
      if(observer&&!product.dataset.orangeStickyCopyFitObserved){
        observer.observe(product);
        product.dataset.orangeStickyCopyFitObserved='true';
      }
      fitStickyCopy(product);
    });
    fitting=false;
  }
  function schedule(){
    if(scheduled||fitting)return;
    scheduled=true;
    requestAnimationFrame(function(){scheduled=false;refresh();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(schedule);
  if(typeof MutationObserver==='function'){
    new MutationObserver(function(records){
      if(fitting)return;
      for(var i=0;i<records.length;i++){
        var record=records[i];
        var target=record.target.nodeType===1?record.target:record.target.parentElement;
        if(record.type==='attributes'&&target&&target.matches&&(
          (target.matches('.orange-sticky-cart')&&(record.attributeName==='class'||record.attributeName==='hidden'))||
          (record.attributeName==='hidden'&&target.closest('.orange-sticky-cart__copy'))
        )){schedule();return;}
        if((record.type==='characterData'||record.type==='childList')&&target&&target.closest&&target.closest('.orange-sticky-cart__copy')){schedule();return;}
        if(record.type==='characterData'&&record.target.parentElement&&record.target.parentElement.closest(cardSelector)){schedule();return;}
        if(record.type==='childList'&&Array.prototype.some.call(record.addedNodes,function(node){
          return node.nodeType===1&&((node.matches&&node.matches(cardSelector+', .orange-sticky-cart__product'))||(node.querySelector&&node.querySelector(cardSelector+', .orange-sticky-cart__product')));
        })){schedule();return;}
      }
    }).observe(document.documentElement,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','hidden']});
  }
})();